import { useCookies } from 'react-cookie';

export const useAuth = () => {
    const [cookies] = useCookies(['token']);

    const getToken = () => cookies.token;

    return {
        getToken,
    };
}; 